import React, { useEffect, useState } from 'react'

import Breadcrumb from '../../components/breadcrumb/Breadcrumb'
import { Helmet } from 'react-helmet'
import axios from 'axios';
const Gallery = () => {
    const [data, setData] = useState([]);

    const getGallery = async () => {
        const response = await axios.get("https://dev.shivcomputers.in/api/v1/gallery");
        setData(response.data);
        console.log(response.data);
        // alert(response.data);

    }
    useEffect(() => {
        getGallery();
    }, []);
    return (
        <>
            <Helmet>
                <title>Gallery || Shiv computers</title>
            </Helmet>
            <Breadcrumb title="Gallery" />
            <div className="container ">
                <div className="row ">
                    {/* fetch data */}
                    {data.map((item) => (
                        <div className="col-md-4 py-4" key={item.id}>
                            <img src={item.img} className="img-thumbnail" alt={item.img} />
                            <br />
                            <h4>{item.name.charAt(0).toUpperCase() + item.name.slice(1)}</h4>

                        </div>
                    ))}

                </div>


            </div>
        </>
    )
}

export default Gallery